import styled from 'styled-components';
import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';
import ColorConstants from '../../../../shared/constants/ColorConstants';


export const SegmentedGraphWrapper = styled.div`
    border-radius: 4px;
    border: 1px solid ${ColorConstants['violent-violet-13%']};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 30px;
    padding: 25px;
`;

export const segmentedGraphStyles = {
    height: '400px !important',
    [`@media ${MobileScreen}`]: {
        height: '350px',
        width: 'calc(100vw - 65px)',
    },
};
